import React from 'react';
import { Instagram, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1a1c1b] border-t border-[#3f4816] py-12">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="heading-6 text-[#d9fb06] mb-4">
              Tu Nombre en el Campo
            </h3>
            <p className="body-small text-[#888680] max-w-sm">
              Marca Personal para Entrenadores de Fútbol Noveles. 
              Una guía completa para construir tu identidad profesional en el fútbol.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="caption text-[#d9fb06] mb-4">
              NAVEGACIÓN
            </h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => document.getElementById('sobre-libro')?.scrollIntoView({ behavior: 'smooth' })}
                  className="body-small text-[#888680] hover:text-[#d9fb06] transition-colors"
                >
                  Sobre el Libro
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('target-audience')?.scrollIntoView({ behavior: 'smooth' })}
                  className="body-small text-[#888680] hover:text-[#d9fb06] transition-colors"
                >
                  Para Quién es
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('chapters')?.scrollIntoView({ behavior: 'smooth' })}
                  className="body-small text-[#888680] hover:text-[#d9fb06] transition-colors"
                >
                  Contenido
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('author')?.scrollIntoView({ behavior: 'smooth' })}
                  className="body-small text-[#888680] hover:text-[#d9fb06] transition-colors"
                >
                  Autor
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="body-small text-[#888680] hover:text-[#d9fb06] transition-colors"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="caption text-[#d9fb06] mb-4">
              CONECTA CON NOSOTROS
            </h4>
            <div className="flex gap-4 mb-6">
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-[#3f4816] flex items-center justify-center hover:bg-[#d9fb06] transition-colors group"
                aria-label="Instagram"
              >
                <Instagram className="text-[#d9fb06] group-hover:text-[#1a1c1b]" size={20} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-[#3f4816] flex items-center justify-center hover:bg-[#d9fb06] transition-colors group"
                aria-label="LinkedIn"
              >
                <Linkedin className="text-[#d9fb06] group-hover:text-[#1a1c1b]" size={20} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-[#3f4816] flex items-center justify-center hover:bg-[#d9fb06] transition-colors group"
                aria-label="Email"
              >
                <Mail className="text-[#d9fb06] group-hover:text-[#1a1c1b]" size={20} />
              </a>
            </div>
            <p className="body-small text-[#888680]">
              Por Edgar Merino Vidangossy
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#3f4816] text-center">
          <p className="body-small text-[#888680]">
            © {currentYear} Tu Nombre en el Campo. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
